const breadCrumb = "Lançamento de Notas - Lançamento de Notas/Conceitos/Faltas";

const routes = [
  {
    path: "/consultar-resumo-de-lancamento-de-notas-conceitos/:id/:periodoId/turmas-fechadas",
    name: "consultar-resumo-de-lancamento-de-notas-conceitos-turmas-fechadas",
    meta: {
      requireAuth: false,
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/ConsultarResumoDeLancamentoDeNotasConceitos/ConsultarResumoDeLancamentoDeNotasConceitosTurmasFechadas.vue"
      ),
  },
  {
    path: "/consultar-resumo-de-lancamento-de-notas-conceitos/:id/turmas-fechadas/:turmaId",
    name: "consultar-resumo-de-lancamento-de-notas-conceitos-turmas-fechadas-detalhe",
    meta: {
      requireAuth: false,
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/ConsultarResumoDeLancamentoDeNotasConceitos/TurmasFechadas/DisciplinaAreaDoConhecimento.vue"
      ),
  },
  {
    path: "/consultar-resumo-de-lancamento-de-notas-conceitos/:id/turmas-fechadas/:turmaId/alunos-sem-nota-zero/:resumoId",
    name: "consultar-resumo-de-lancamento-de-notas-conceitos-turmas-fechadas-alunos-sem-nota-zero",
    meta: {
      requireAuth: false,
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/ConsultarResumoDeLancamentoDeNotasConceitos/TurmasFechadas/AlunosSemNotaZero.vue"
      ),
  },
  {
    path: "/consultar-resumo-de-lancamento-de-notas-conceitos/:id/turmas-fechadas/:turmaId/alunos-com-nota-zero/:resumoId",
    name: "consultar-resumo-de-lancamento-de-notas-conceitos-turmas-fechadas-alunos-com-nota-zero",
    meta: {
      requireAuth: false,
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/ConsultarResumoDeLancamentoDeNotasConceitos/TurmasFechadas/AlunosComNotaZero.vue"
      ),
  },
];

export default routes;
